module.exports = " <div v-if=canShow class=list _v-15e0c332=\"\"> <span class=title _v-15e0c332=\"\">{{ title }}</span> <div class=body _v-15e0c332=\"\"> <list-item v-for=\"info in list\" :id=$key :info=info :list-type=listType _v-15e0c332=\"\"></list-item> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-15e0c332!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/body/discover/List.vue
 ** module id = 334
 ** module chunks = 2
 **/